export const TOKEN_INFO_SESSION_STORAGE_KEY = "accessTokenInfo_v2";
export const VARIANT_TUNNEL_STORAGE_KEY = "X-Backend-Variant";
export const DEFAULT_DETECT_VOLUME = 100;
export const MI1_RESAMPLING_RATE = 11025;
export const CALIBRATION_MIN_LOG_POWER = 40;
export const CALIBRATION_MAX_LOG_POWER = 90;
